import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { map, Observable } from 'rxjs';
import { Environment } from 'src/environments/environment.model';

import { GetSoilAnalysesResponse, SoilAnalysis } from '../map.models';

@Injectable({
  providedIn: 'root',
})
export class SoilAnalysisApiService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  private readonly baseUrl = `${this.env.APIM_BASE_URL}/arable-service/fieldregistration/soilanalysis`;

  fetchSoilAnalyses(cropYear: number): Observable<SoilAnalysis[]> {
    return this.http
      .get<GetSoilAnalysesResponse>(`${this.baseUrl}/year/${cropYear}`)
      .pipe(map((response) => response.soilAnalyses ?? []));
  }
}
